import ProjectCore, { IProject } from "./ProjectCore";

export interface IProjectLiabilityEconomic extends IProject {}

export default class ProjectLiabilityEconomic extends ProjectCore {
  constructor(dto: IProjectLiabilityEconomic) {
    super(dto);
  }
}
